var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhyus1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1041_157)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1041_157",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 49,
    height: 48
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 3.8147e-06H48.5V48H0.5V3.8147e-06Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1041_157)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.125 20.625C21.125 22.696 19.446 24.375 17.375 24.375H6.125C4.05397 24.375 2.375 22.696 2.375 20.625V5.625C2.375 3.55397 4.05397 1.875 6.125 1.875H17.375C19.446 1.875 21.125 3.55397 21.125 5.625V20.625Z",
    stroke: "#4A8AF8",
    strokeWidth: 4.6875,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.625 42.375C46.625 44.446 44.946 46.125 42.875 46.125H31.625C29.554 46.125 27.875 44.446 27.875 42.375V27.375C27.875 25.304 29.554 23.625 31.625 23.625H42.875C44.946 23.625 46.625 25.304 46.625 27.375V42.375Z",
    stroke: "#4A8AF8",
    strokeWidth: 4.6875,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.125 42.375C21.125 44.446 19.446 46.125 17.375 46.125H6.125C4.05397 46.125 2.375 44.446 2.375 42.375V34.875C2.375 32.804 4.05397 31.125 6.125 31.125H17.375C19.446 31.125 21.125 32.804 21.125 34.875V42.375Z",
    stroke: "#4A8AF8",
    strokeWidth: 4.6875,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.625 13.125C46.625 15.196 44.946 16.875 42.875 16.875H31.625C29.554 16.875 27.875 15.196 27.875 13.125V5.625C27.875 3.55397 29.554 1.875 31.625 1.875H42.875C44.946 1.875 46.625 3.55397 46.625 5.625V13.125Z",
    stroke: "#4A8AF8",
    strokeWidth: 4.6875,
    strokeMiterlimit: 10
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1041_157"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhyus1);
export default __webpack_public_path__ + "static/media/whyus1.f46d68c44f0c52afb62aa3983c375e85.svg";
export { ForwardRef as ReactComponent };